<template>
  <!-- 手环维护新增/编辑表单 -->
  <a-modal
    :title="formTitle || '新增手环维护'"
    v-model:visible="open"
    @cancel="onClose"
    :width="1100"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ flex: '0 0 150px' }" :wrapper-col="{ flex: '1 1 auto' }" class="two-column-form">
      <a-row :gutter="24">
        <a-col :span="12">
          <!-- 手环MAC：自动填充且禁用 -->
          <a-form-model-item :label="nameLabel" prop="name">
            <a-input v-model:value="form.name" placeholder="自动填入" disabled />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="故障现象" prop="malfunctionSymptoms">
            <a-input
              v-model:value="form.malfunctionSymptoms"
              placeholder="请输入故障现象"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="故障原因" prop="causeOfFailure">
            <a-input
              v-model:value="form.causeOfFailure"
              placeholder="请输入故障原因"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="维修费用" prop="price">
            <a-input-number
              v-model:value="form.price"
              :min="0"
              :step="0.01"
              :precision="2"
              placeholder="请输入维修费用"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="维保状态" prop="maintenanceStatus">
            <a-select
              v-model:value="form.maintenanceStatus"
              placeholder="请选择维保状态"
              allow-clear
              style="width: 100%"
            >
              <a-select-option
                v-for="(d, index) in dict.type['maintenance_status']"
                :key="index"
                :value="d.value"
              >
                {{ d.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="维修物流信息" prop="logisticsInformation">
            <a-input
              v-model:value="form.logisticsInformation"
              placeholder="请输入维修物流信息"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="时间" prop="operationTime">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.operationTime"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              :show-time="{ format: 'HH:mm:ss' }"
              placeholder="请选择时间"
              allow-clear
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 手环维护新增/编辑表单组件
 *
 * 功能说明：
 * 1. 支持新增和编辑手环维护记录
 * 2. 手环MAC自动填充且禁用
 * 3. 自动设置维护类型为"手环维护"
 * 4. 时间选择支持年月日时分秒格式
 * 5. 维修费用使用数字输入框，支持小数，最小值为0
 *
 * @author zbtech
 * @date 2025-01-XX
 */
import {
  getEquipmentMaintenance,
  addEquipmentMaintenance,
  updateEquipmentMaintenance,
} from '@/api/system/equipmentMaintenance'

export default {
  name: 'WristbandMaintenanceCreateForm',
  // 使用的字典类型：维保类型、维保状态
  dicts: ['maintenance_type', 'maintenance_status'],
  props: {
    // 手环ID（用于关联维护记录）
    wristbandId: {
      type: Number,
      default: null,
    },
    // 岗位名称（用于显示在表单中）
    wristbandName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 提交按钮加载状态
      submitLoading: false,
      // 表单标题（添加/修改）
      formTitle: '',
      // 表单数据对象
      form: {
        id: null, // 主键ID
        type: null, // 维护类型（自动设置为"手环维护"）
        name: null, // 手环MAC（自动填充，禁用）
        malfunctionSymptoms: null, // 故障现象
        causeOfFailure: null, // 故障原因
        price: null, // 维修费用
        maintenanceStatus: undefined, // 维保状态（字典值）
        logisticsInformation: null, // 维修物流信息
        operationTime: null, // 操作时间（年月日时分秒）
        maintenanceId: null, // 维护ID（关联手环ID）
      },
      // 表单类型：1-新增，2-修改
      formType: 1,
      // 抽屉显示/隐藏状态
      open: false,
      // 表单验证规则
      rules: {
        name: [{ required: true, message: '请输入手环MAC', trigger: 'blur' }],
        malfunctionSymptoms: [
          { required: true, message: '请输入故障现象', trigger: 'blur' },
        ],
        causeOfFailure: [
          { required: true, message: '请输入故障原因', trigger: 'blur' },
        ],
        price: [
          { required: true, message: '请输入维修费用', trigger: 'blur' },
          {
            type: 'number',
            min: 0,
            message: '维修费用不能小于0',
            trigger: 'blur',
          },
        ],
        maintenanceStatus: [
          { required: true, message: '请选择维保状态', trigger: 'change' },
        ],
        logisticsInformation: [
          { required: true, message: '请输入维修物流信息', trigger: 'blur' },
        ],
        operationTime: [
          { required: true, message: '请选择时间', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    /**
     * 名称标签
     * 返回"手环MAC"作为标签文本
     */
    nameLabel() {
      return '手环MAC'
    },
  },
  methods: {
    /**
     * 关闭抽屉
     */
    onClose() {
      this.open = false
    },
    /**
     * 取消按钮操作
     * 关闭抽屉并重置表单
     */
    cancel() {
      this.open = false
      this.reset()
    },
    /**
     * 表单重置
     * 清空所有表单字段
     */
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        name: null,
        malfunctionSymptoms: null,
        causeOfFailure: null,
        price: null,
        maintenanceStatus: undefined,
        logisticsInformation: null,
        operationTime: null,
        maintenanceId: null,
      }
    },
    /**
     * 新增按钮操作
     * 打开新增表单，自动填充岗位名称、ID和类型
     * @param {Number} wristbandId - 手环ID
     * @param {String} wristbandName - 岗位名称
     */
    handleAdd(wristbandId, wristbandName) {
      this.reset()
      this.formType = 1
      // 填充岗位名称
      this.form.name = wristbandName || this.wristbandName
      // 获取手环ID（优先使用传入的参数）
      const targetId = wristbandId || this.wristbandId
      if (targetId) {
        // 设置维护ID（关联手环ID）
        this.form.maintenanceId = targetId
        // 从字典中查找"手环维护"类型并设置
        const maintenanceTypeDict = this.dict.type['maintenance_type'] || []
        const wristbandType = maintenanceTypeDict.find(
          (item) => item.label === '手环维护'
        )
        if (wristbandType) {
          this.form.type = wristbandType.value
        }
      }
      this.open = true
      this.formTitle = '添加'
    },
    /**
     * 修改按钮操作
     * 根据ID获取维护详情，填充表单并打开编辑表单
     * @param {Object} row - 行数据对象
     * @param {Number|Array} ids - ID或ID数组（备用参数）
     */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      // 获取维护详情
      getEquipmentMaintenance({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /**
     * 提交表单
     * 验证表单后，根据formType决定调用新增或修改接口
     */
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        // 判断是修改还是新增，并调用对应的接口
        const action =
          this.form.id !== undefined && this.form.id !== null
            ? updateEquipmentMaintenance(this.form)
            : addEquipmentMaintenance(this.form)
        action
          .then(() => {
            this.$message.success(this.form.id ? '修改成功' : '新增成功', 3)
            this.open = false
            $emit(this, 'ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
  },
  emits: ['ok'],
}
</script>

<style scoped>
.create-form-modal :deep(.ant-modal-body) {
  max-height: 75vh;
  overflow-y: auto;
  padding: 20px 24px 20px 24px !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.create-form-modal :deep(.ant-form-item) {
  margin-bottom: 16px;
}

.create-form-modal :deep(.ant-form-item:last-of-type) {
  margin-bottom: 24px;
}

.create-form-modal :deep(.ant-form-item-label) {
  padding-bottom: 6px;
  flex: 0 0 150px !important;
  max-width: 150px !important;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-row) {
  margin-bottom: 0;
}

.two-column-form :deep(.ant-col) {
  margin-bottom: 16px;
}

.two-column-form :deep(.ant-form-item) {
  margin-bottom: 0;
}

/* 保存按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
  opacity: 1;
}

.save-btn:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

/* 取消按钮样式 */
.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.cancel-btn:focus {
  background-color: #F2F2F2 !important;
  border-color: #F2F2F2 !important;
  color: #333333 !important;
}
</style>

<style>
/* 输入框样式 - 使用非 scoped 样式确保生效 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus,
.create-form-modal .ant-input:disabled {
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 日期选择器样式 */
.create-form-modal .ant-picker,
.create-form-modal .ant-picker:hover,
.create-form-modal .ant-picker-focused {
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused,
.create-form-modal .ant-input-number:disabled {
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-number-input,
.create-form-modal .ant-input-number-input-wrap {
  border-radius: 4px 4px 4px 4px !important;
}
</style>
